var en = require('./translations/en');

var en_AU = require('./translations/en-AU');

var de = require('./translations/de');

var es = require('./translations/es');

var fr = require('./translations/fr');

var it = require('./translations/it');

var nl = require('./translations/nl');

var pl = require('./translations/pl');

var pt = require('./translations/pt');

var I18n = I18n || {};
I18n.translations = {
  'en': en,
  'en-AU': en_AU,
  'de': de,
  'es': es,
  'fr': fr,
  'it': it,
  'nl': nl,
  'pl': pl,
  'pt': pt
};
module.exports = I18n;